module.exports = __webpack_public_path__ + "static/media/MiniRaboot.4941eb22.png";